// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"inputComponent_wrapper__bih4q","label":"inputComponent_label__1PklD"};